import { put } from "redux-saga/effects";

import { fetchUnsplashAPI, fetchUnsplashImages } from "common/components/unsplash/utils";
import { apiFetch } from "common/utilities";
import { getImageDownloadFile } from "common/utilities/imageDownload";
import { RequestError } from "common/utilities/requestError";
import {
  getAIGeneratedMapDetailsFailure,
  getAIGeneratedMapDetailsNotValidPrompt,
  getAIGeneratedMapDetailsSuccess,
  setMapImage,
} from "domains/createMapDetail/actions";
import { activateModal } from "domains/modal/actions";
import type { GetAIGeneratedTopicDetailsAction } from "domains/topicDetail/actionTypes";
import { errorCodes } from "domains/topicDetail/actionTypes";
import type { Topic } from "entities/topics/types";

export function* getAIGeneratedMapDetailsSaga({ payload }: GetAIGeneratedTopicDetailsAction) {
  try {
    const topic: Topic = yield apiFetch("map/generation", {
      method: "POST",
      body: {
        user_prompt: payload.prompt,
      },
    });
    const { results }: Awaited<ReturnType<typeof fetchUnsplashImages>> = yield fetchUnsplashImages(topic.name);
    const { url: imgSrc } = yield fetchUnsplashAPI(results[0].links.download_location);
    const { dataURL }: Awaited<ReturnType<typeof getImageDownloadFile>> = yield getImageDownloadFile(`${imgSrc}&w=600`);
    yield put(setMapImage(dataURL));

    yield put(getAIGeneratedMapDetailsSuccess(topic));
  } catch (error) {
    if (error instanceof RequestError && Object.values(errorCodes).includes(error.status))
      yield put(getAIGeneratedMapDetailsNotValidPrompt(error.status));
    else {
      yield put(getAIGeneratedMapDetailsFailure());
      yield put(activateModal({ id: "Error" }));
    }
  }
}
